<template>
  <base-material-card color="primary" icon="mdi-chart-line" inline class="mx-auto px-5 py-5">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        {{ title }}
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field id="titulo-aging" v-model="campos.titulo" label="Título" outlined :error-messages="errors" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12" md="6" class="pr-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              id="tipo-base-aging"
              v-model="campos.tipoBase"
              :items="tipoBaseList"
              label="Tipo da Base"
              outlined
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
        <v-col cols="12" md="6" class="pl-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              id="tucs-aging"
              v-model="campos.tucs"
              :items="tucOptions"
              label="TUCs"
              outlined
              multiple
              chips
              small-chips
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4">
        <v-col id="date-picker-data-base-aging" cols="12" md="6" class="pr-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <date-picker v-model="campos.dataBase" label="Data Base" type="month" rules="required|min:7" />
            <span v-if="errors.length" class="red--text text-caption">{{ errors[0] }}</span>
          </validation-provider>
        </v-col>
        <v-col id="date-picker-data-projetada-aging" cols="12" md="6" class="pl-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <date-picker v-model="campos.dataProjetada" label="Data Projetada" type="month" rules="required|min:7" />
            <span v-if="errors.length" class="red--text text-caption">{{ errors[0] }}</span>
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import TabelasService from '@/services/TabelasService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'ParametrosAging',

    components: {
      DatePicker: () => import('@/components/general/DatePicker.vue')
    },

    mixins: [dateFormatterMixins],

    props: {
      item: {
        type: Object,
        default: () => ({
          titulo: '',
          data_base: '',
          data_projetada: '',
          tipo_base: 'AIS',
          tucs: []
        })
      },
      title: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        campos: {
          titulo: '',
          dataBase: '',
          dataProjetada: '',
          tipoBase: 'AIS',
          tucs: []
        },
        tipoBaseList: ['AIS', 'LAUDO'],
        tucOptions: ['125', '160', '190', '210', '255', '295', '340', '345', '565', '570', '575', '580'],
        skipAutoFillDataBase: false
      };
    },

    mounted() {
      if (!this.$route.params.id) {
        this.preencherDataBase(this.campos.tipoBase);
      }
    },

    methods: {
      fillFields() {
        this.skipAutoFillDataBase = true;
        this.campos.titulo = this.item.titulo || '';
        this.campos.dataBase = this.getOnlyDateIgnoringTimestamp(this.item.data_base);
        this.campos.dataProjetada = this.getOnlyDateIgnoringTimestamp(this.item.data_projetada);
        this.campos.tipoBase = this.item.tipo_base === 'AMBOS' ? 'AIS' : this.item.tipo_base || 'AIS';
        this.campos.tucs = Array.isArray(this.item.tucs) ? this.item.tucs.map(String) : [];
        this.$nextTick(() => {
          this.skipAutoFillDataBase = false;
        });
      },

      preencherDataBase(tipoBase) {
        return TabelasService.getTabelaResumo()
          .then((response) => {
            const resumo = response.data.tabela_resumo;
            let dataBase = tipoBase === 'LAUDO' ? resumo.data_base_laudo_blindado : resumo.data_base_ais;

            if (dataBase && dataBase.length <= 7) {
              dataBase = `${dataBase}-01`;
            }

            this.campos.dataBase = dataBase;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar última data base', '', { position: 'topRight' });
          });
      },

      exportData() {
        return {
          titulo: this.campos.titulo,
          data_base: this.campos.dataBase,
          data_projetada: this.campos.dataProjetada,
          tipo_base: this.campos.tipoBase,
          tucs: this.campos.tucs
        };
      },

      getOnlyDateIgnoringTimestamp(date) {
        if (date && date.length > 10) {
          return date.substr(0, 10);
        }

        return date;
      }
    },

    watch: {
      'campos.tipoBase'(tipoBase) {
        if (!this.skipAutoFillDataBase && tipoBase) {
          this.preencherDataBase(tipoBase);
        }
      },

      item: {
        handler() {
          this.fillFields();
        },
        deep: true,
        immediate: true
      }
    }
  };
</script>
